import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showBlocker, hideBlocker } from '../../actions/blocker';
import { getSignature } from '../../actions/auth';
import { fetchFlightBriefingSheet, saveFlightBriefingSheet } from '../../actions/flight-list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faRedo, faTimesCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import Preview from './preview';
import { getInputs, getUTCDateTime } from '../../utils';

class BriefingSheet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            general: { dDate: '', flt: '', reg: '', acTyp: '', dIcao: '', etd: '', aIcao: '', eta: '', dBay: '', fic: '', adc: '', capName: '', foName: '', cat: '' },
            alt: { takeOff: '', dest1: '', dest2: '', },
            metar: { dep: '', arr: '', takeOffAlt: '', destAlt1: '', destAlt2: '', },
            weight: { stTow: '', stLw: '', stZfw: '', otow: '', olw: '', ezfw: '', },
            fuel: { trip: '', minDisp: '', destHold: '', extra: '', ramp: '', },
            compFreq: { vhf: '', hfDay: '', hfNight: '', },
            mel: [''],
            cdl: [''],
            extra: { remark: '', closure: '', permit: '' },
            efb: { aerodoc: '', opt: '', ddg: '', jeppesen: '', iqrh: '' },
            dispatchers: [],
            creator: { username: this.props.username, name: '', sign: '' },

            preview: false,
        };
        this.setPreview = this.setPreview.bind(this);
        this.save = this.save.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onChangeMelCdl = this.onChangeMelCdl.bind(this);
        this.addNewMelCdl = this.addNewMelCdl.bind(this);
        this.removeMelCdl = this.removeMelCdl.bind(this);
        this.setData = this.setData.bind(this);
    }

    componentWillMount() {
        this.setData();
    }

    setData() {
        this.props.showBlocker();
        this.props.fetchFlightBriefingSheet(this.props.id, this.props.options)
            .done((data, textStatus, jqXHR) => {
                const { general, alt, metar, weight, fuel, compFreq, mel, cdl, extra, efb, dispatchers } = data;

                if (general.std) {
                    general.dDate = getUTCDateTime(general.std, 'D-M-Y');
                }

                if (general.etd) {
                    general.etd = getUTCDateTime(general.etd, 'h:m');
                } else {
                    general.etd = getUTCDateTime(general.std, 'h:m');
                }

                if (general.eta) {
                    general.eta = getUTCDateTime(general.eta, 'h:m');
                } else {
                    general.eta = getUTCDateTime(general.sta, 'h:m');
                }

                this.setState({
                    general: general || this.state.general,
                    alt: alt || this.state.alt,
                    metar: metar || this.state.metar,
                    weight: weight || this.state.weight,
                    fuel: fuel || this.state.fuel,
                    compFreq: compFreq || this.state.compFreq,
                    mel: (Array.isArray(mel) && mel.length && mel) || this.state.mel,
                    cdl: (Array.isArray(cdl) && cdl.length && cdl) || this.state.cdl,
                    extra: extra || this.state.extra,
                    efb: efb || this.state.efb,
                    dispatchers: dispatchers || this.state.dispatchers,
                });
            })
            .fail((jqXHR, status, error) => null)
            .always(this.props.hideBlocker);
    }

    setPreview(isPreview) {
        this.props.showBlocker();
        if (isPreview) {
            this.props.getSignature(this.state.creator.username)
                .done(data => this.setState({ creator: { ...this.state.creator, ...data } }))
                .always(_ => {
                    this.setState({ preview: true });
                    this.props.hideBlocker();
                });
        } else {
            this.setState({ preview: false });
            this.props.hideBlocker();
        }
    }

    save(html) {
        this.props.showBlocker();
        return this.props.saveFlightBriefingSheet(this.props.id, { html })
            .done((data, textStatus, jqXHR) => {
                this.setPreview(false);
                this.props.setDocs();
            })
            .fail((jqXHR, status, error) => null)
            .always(this.props.hideBlocker);
    }

    onChangeInput(e) {
        const el = e.target ? e.target : e;
        const path = el.name.split('.');
        const change = { [path[0]]: { ...this.state[path[0]] } };
        change[path[0]][path[1]] = el.value;
        this.setState(change);
    }

    onChangeMelCdl(e, typ, index) {
        e.preventDefault();
        const val = e.currentTarget.value;
        const change = [...this.state[typ]];
        change.splice(index, 1, val);
        this.setState({ [typ]: change });
    }

    addNewMelCdl(e, typ) {
        e.preventDefault();
        if (this.state[typ][this.state[typ].length - 1].trim()) {
            this.setState({ [typ]: [...this.state[typ], ''] });
        }
    }

    removeMelCdl(e, typ, index) {
        e.preventDefault();
        const change = {};
        change[typ] = [...this.state[typ]];
        if (change[typ].length === 1) {
            change[typ][0] = '';
        } else {
            change[typ].splice(index, 1);
        }
        this.setState(change);
    }

    render() {
        const fields = {
            general: getInputs([
                {
                    label: 'Date',
                    name: 'general.dDate',
                    width: 3,
                    value: this.state.general.dDate,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Flight Number',
                    name: 'general.flt',
                    width: 3,
                    autoCapitalize: true,
                    value: this.state.general.flt,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Tail Number',
                    name: 'general.reg',
                    width: 3,
                    value: this.state.general.reg,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Aircraft Type',
                    name: 'general.acTyp',
                    width: 3,
                    value: this.state.general.acTyp,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Departure',
                    name: 'general.dIcao',
                    width: 3,
                    value: this.state.general.dIcao,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'ETD',
                    name: 'general.etd',
                    width: 3,
                    value: this.state.general.etd,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Destination',
                    name: 'general.aIcao',
                    width: 3,
                    value: this.state.general.aIcao,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'ETA',
                    name: 'general.eta',
                    width: 3,
                    value: this.state.general.eta,
                    onChange: this.onChangeInput,
                },
                {
                    label: 'Bay',
                    name: 'general.dBay',
                    width: 3,
                    value: this.state.general.dBay,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'FIC',
                    name: 'general.fic',
                    width: 3,
                    value: this.state.general.fic,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'ADC',
                    name: 'general.adc',
                    width: 3,
                    value: this.state.general.adc,
                    onChange: this.onChangeInput,
                    required: true,
                },
            ]),
            fuel: getInputs([
                {
                    label: 'Trip Fuel',
                    name: 'fuel.trip',
                    value: this.state.fuel.trip,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Minimum Dispatch Fuel',
                    name: 'fuel.minDisp',
                    value: this.state.fuel.minDisp,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Destination Hold',
                    name: 'fuel.destHold',
                    value: this.state.fuel.destHold,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Extra',
                    name: 'fuel.extra',
                    value: this.state.fuel.extra,
                    onChange: this.onChangeInput,
                },
                {
                    label: 'Total Fuel Uplifted',
                    name: 'fuel.ramp',
                    value: this.state.fuel.ramp,
                    onChange: this.onChangeInput,
                },
            ]),
            alt: getInputs([
                {
                    label: 'Take Off Alt',
                    name: 'alt.takeOff',
                    width: 4,
                    value: this.state.alt.takeOff,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Dest Alt 1',
                    name: 'alt.dest1',
                    width: 4,
                    value: this.state.alt.dest1,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Dest Alt 2',
                    name: 'alt.dest2',
                    width: 4,
                    value: this.state.alt.dest2,
                    onChange: this.onChangeInput,
                    required: true,
                },
            ]),
            metar: getInputs([
                {
                    label: 'Departure',
                    name: 'metar.dep',
                    type: 'textarea',
                    width: 6,
                    value: this.state.metar.dep,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Destination',
                    name: 'metar.arr',
                    type: 'textarea',
                    width: 6,
                    value: this.state.metar.arr,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Take Off Alt',
                    name: 'metar.takeOffAlt',
                    type: 'textarea',
                    width: 6,
                    value: this.state.metar.takeOffAlt,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Dest Alt 1',
                    name: 'metar.destAlt1',
                    type: 'textarea',
                    width: 6,
                    value: this.state.metar.destAlt1,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Dest Alt 2',
                    name: 'metar.destAlt2',
                    type: 'textarea',
                    width: 6,
                    value: this.state.metar.destAlt2,
                    onChange: this.onChangeInput,
                    required: true,
                }
            ]),
            weight: getInputs([
                {
                    label: 'ST TOW',
                    name: 'weight.stTow',
                    width: 4,
                    value: this.state.weight.stTow,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'ST LW',
                    name: 'weight.stLw',
                    width: 4,
                    value: this.state.weight.stLw,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'ST ZFW',
                    name: 'weight.stZfw',
                    width: 4,
                    value: this.state.weight.stZfw,
                    onChange: this.onChangeInput,
                    required: true,
                },

                {
                    label: 'OTOW',
                    name: 'weight.otow',
                    width: 4,
                    value: this.state.weight.otow,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'OLW',
                    name: 'weight.olw',
                    width: 4,
                    value: this.state.weight.olw,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'EZFW',
                    name: 'weight.ezfw',
                    width: 4,
                    value: this.state.weight.ezfw,
                    onChange: this.onChangeInput,
                    required: true,
                },
            ]),
            compFreq: getInputs([
                {
                    label: 'VHF',
                    name: 'compFreq.vhf',
                    width: 4,
                    value: this.state.compFreq.vhf,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'HF (Day)',
                    name: 'compFreq.hfDay',
                    width: 4,
                    value: this.state.compFreq.hfDay,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'HF (Night)',
                    name: 'compFreq.hfNight',
                    width: 4,
                    value: this.state.compFreq.hfNight,
                    onChange: this.onChangeInput,
                    required: true,
                },
            ]),
            extra: getInputs([
                {
                    label: 'Remark',
                    name: 'extra.remark',
                    type: 'textarea',
                    width: 6,
                    value: this.state.extra.remark,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Closure',
                    name: 'extra.closure',
                    type: 'textarea',
                    width: 6,
                    value: this.state.extra.closure,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'Permit',
                    name: 'extra.permit',
                    type: 'textarea',
                    width: 6,
                    value: this.state.extra.permit,
                    onChange: this.onChangeInput,
                    required: true,
                },
            ]),
            efb: getInputs([
                {
                    label: 'Jeppesen',
                    name: 'efb.jeppesen',
                    type: 'textarea',
                    rows: 10,
                    value: this.state.efb.jeppesen,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'OPT',
                    name: 'efb.opt',
                    type: 'textarea',
                    rows: 10,
                    value: this.state.efb.opt,
                    onChange: this.onChangeInput,
                    required: true,
                },
                {
                    label: 'DDG',
                    name: 'efb.ddg',
                    type: 'textarea',
                    rows: 10,
                    value: this.state.efb.ddg,
                    onChange: this.onChangeInput,
                    required: true,
                },
                // {
                //     label: 'Aerodoc',
                //     name: 'efb.aerodoc',
                //     type: 'textarea',
                //     rows: 10,
                //     value: this.state.efb.aerodoc,
                //     onChange: this.onChangeInput,
                //     required: true,
                // },
                {
                    label: ' Spice Airdocs',
                    name: 'efb.iqrh',
                    type: 'textarea',
                    rows: 10,
                    value: this.state.efb.iqrh,
                    onChange: this.onChangeInput,
                    required: true,
                },
            ]),
            creator: getInputs([
                {
                    label: 'Dispatcher',
                    name: 'creator.username',
                    type: 'typeahead',
                    options: this.state.dispatchers,
                    value: this.state.creator.username,
                    onChange: this.onChangeInput,
                },
                {
                    label: 'Captain',
                    name: 'general.capName',
                    value: this.state.general.capName,
                    onChange: this.onChangeInput,
                },
                {
                    label: 'First Officer',
                    name: 'general.foName',
                    value: this.state.general.foName,
                    onChange: this.onChangeInput,
                }
            ]),
        }

        return (
            <>
                {
                    this.state.preview ?
                        <div className='position-fixed vh-100 vw-100'
                            style={{ top: 0, right: 0, bottom: 0, left: 0, zIndex: 9, }}>
                            <div className='bg-light h-100 w-100' style={{ opacity: 0.3 }}></div>
                            <div className='position-absolute' style={{ top: 0 }}>
                                <Preview setPreview={this.setPreview} save={this.save} {...this.state} />
                            </div>
                        </div> : null
                }
                <div className='mt-1'>
                    <button className='btn btn-sm btn-light'
                        onClick={e => {
                            e.preventDefault();
                            this.setPreview(true);
                        }}>
                        <i><FontAwesomeIcon icon={faFile} /></i> Preview</button>
                    <button className='btn btn-sm btn-light float-right'
                        onClick={this.setData}>
                        <i><FontAwesomeIcon icon={faRedo} /></i> Refresh</button>
                </div>
                <div className='mt-2 form-row'>
                    <div className='form-row'>{fields.general}</div>
                </div>
                <div className='mt-4'>
                    <div className='form-row'>{fields.fuel}</div>
                </div>
                <div className='mt-4'>
                    <div className='form-row'>{fields.alt}</div>
                </div>
                <div className='mt-4'>
                    <span className='h5'>METAR</span>
                    <div className='form-row'>{fields.metar}</div>
                </div>
                <div className='mt-4'>
                    <div className='form-row'>{fields.weight}</div>
                </div>
                <div className='mt-4'>
                    <span className='h5'>COMPANY FREQUENCIES</span>
                    <div className='form-row'>{fields.compFreq}</div>
                </div>
                <div className='mt-4'>
                    <div className='form-row'>
                        <div id='MEL' className='form-group px-3 m-0 col-6'>
                            <span className='small m-0 text-nowrap'>MEL</span>
                            <div className='position-relative'>
                                {
                                    this.state.mel.map((mel, index) => <div className='position-relative' key={index}>
                                        <i className='delete'
                                            onClick={e => this.removeMelCdl(e, 'mel', index)}>
                                            <FontAwesomeIcon icon={faTimesCircle} /></i>
                                        <textarea className='form-control form-control-sm rounded-0 bg-transparent text-light'
                                            rows='2'
                                            placeholder='MEL'
                                            value={mel}
                                            onChange={e => this.onChangeMelCdl(e, 'mel', index)}></textarea>
                                    </div>)
                                }
                                <i className='add-new'
                                    title='Add New MEL'
                                    onClick={e => this.addNewMelCdl(e, 'mel')}>
                                    <FontAwesomeIcon icon={faPlusCircle} /></i>
                            </div>
                        </div>
                        <div id='CDL' className='form-group px-3 m-0 col-6'>
                            <span className='small m-0 text-nowrap'>CDL</span>
                            <div className='position-relative'>
                                {
                                    this.state.cdl.map((cdl, index) => <div className='position-relative' key={index}>
                                        <i className='delete'
                                            onClick={e => this.removeMelCdl(e, 'cdl', index)}>
                                            <FontAwesomeIcon icon={faTimesCircle} /></i>
                                        <textarea className='form-control form-control-sm rounded-0 bg-transparent text-light'
                                            rows='2'
                                            placeholder='CDL'
                                            value={cdl}
                                            onChange={e => this.onChangeMelCdl(e, 'cdl', index)}></textarea>
                                    </div>)
                                }
                                <i className='add-new'
                                    title='Add New CDL'
                                    onClick={e => this.addNewMelCdl(e, 'cdl')}>
                                    <FontAwesomeIcon icon={faPlusCircle} /></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mt-4'>
                    <div className='form-row'>{fields.extra}</div>
                </div>
                <div className='mt-4'>
                    <div className='form-row'>{fields.efb}</div>
                </div>
                <div className='mt-4'>
                    <div className='form-row'>{fields.creator}</div>
                </div>
                <div className='my-2'>
                    <button className='btn btn-sm btn-light'
                        onClick={e => {
                            e.preventDefault();
                            this.setPreview(true);
                        }}>
                        <i><FontAwesomeIcon icon={faFile} /></i> Preview</button>
                    <button className='btn btn-sm btn-light float-right'
                        onClick={this.setData}>
                        <i><FontAwesomeIcon icon={faRedo} /></i> Refresh</button>
                </div>
            </>
        );
    }
};

const mapStateToProps = state => ({ username: state.auth.user.username });

const mapActionsToProps = {
    showBlocker, hideBlocker,
    getSignature,
    fetchFlightBriefingSheet, saveFlightBriefingSheet,
};

export default connect(mapStateToProps, mapActionsToProps)(BriefingSheet);